'use client';

import type { PropsWithChildren } from 'react';
import type { TabsFilterValue } from '../../types/project/tabs';
import {
  createContext,

  useContext,
} from 'react';
import { useProjectTabs } from '../../hooks/useProjectTabs';

const ProjectTabsContext = createContext<ReturnType<typeof useProjectTabs> | undefined>(undefined);

export const useProjectTabsContext = () => {
  const context = useContext(ProjectTabsContext);
  if (!context) {
    throw new Error(
      'useProjectTabsContext must be called within ProjectTabsProvider',
    );
  }
  return context;
};

export const ProjectTabsProvider = ({
  children,
  defaultTab,
  id,
}: PropsWithChildren<{
  defaultTab: TabsFilterValue;
  id?: number;
}>) => {
  const value = useProjectTabs(defaultTab, id);

  return (
    <ProjectTabsContext.Provider value={value}>
      {children}
    </ProjectTabsContext.Provider>
  );
};
